/* eslint-disable class-methods-use-this */
import ApiService from '../common/api.service'
import decrypt from '../common/decrypt'

class SummaryReportService {
  getSummaryInfo(data) {
    return ApiService.query('/summary-report/info', data).then(response => Promise.resolve(decrypt(response.data.data)), error => Promise.reject(error))
  }

  exportSummaryInfo(data) {
    return ApiService.query('export/summary-report/info', data).then(response => Promise.resolve(response.data), error => Promise.reject(error))
  }

  getTotalTransectionByDate(data) {
    return ApiService.query('success/transection/sale/count', data).then(response => Promise.resolve(decrypt(response.data.data)), error => Promise.reject(error))
  }

  getReloadCount(data) {
    return ApiService.query('summary-report/reload/count', data).then(response => Promise.resolve(decrypt(response.data.data)), error => Promise.reject(error))
  }

  getDebitNoteCount(data) {
    return ApiService.query('summary-report/debit/count', data).then(response => Promise.resolve(decrypt(response.data.data)), error => Promise.reject(error))
  }

  getTransferCount(data) {
    return ApiService.query('summary-report/transfer/count', data).then(response => Promise.resolve(decrypt(response.data.data)), error => Promise.reject(error))
  }
  downloadSummaryReport(data) {
    return ApiService.downloadPdf('download/summary-report', data).then(response => Promise.resolve(response.data), error => Promise.reject(error))
  }
}

export default new SummaryReportService()
